import React, { useState, useRef } from "react";
import useClickOutside from "../../../hooks/useClickOutside";

/** Down chevron (#6C757D); rotate when open — used by version history popup */
function GreyChevronDropdownIcon({ open }) {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "block",
        flexShrink: 0,
        transform: open ? "rotate(180deg)" : "none",
        transition: "transform 0.15s ease",
      }}
      aria-hidden
    >
      <path
        d="M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z"
        fill="#6C757D"
      />
    </svg>
  );
}

const FilterDropdown = ({
  filterType,
  setFilterType,
  disableFilter,
  disabledFltrOptions = [],
  filterOptions = [],
  /** When true, use grey SVG chevron instead of ▲/▼ (e.g. Select Version for Comparison) */
  greyChevronDropdownIcon = false,
}) => {
  let disablingStyle = {};
  if (disableFilter) {
    disablingStyle = { pointerEvents: "none", opacity: 0.7 };
  }
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(); // ✅ added ref
  useClickOutside(dropdownRef, () => setIsDropdownOpen(false));
  return (
    <>
      <div
        className="filter-dropdown"
        style={{ width: "80%" }}
        ref={dropdownRef}
      >
        <div
          className="dropdown-header"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          style={disablingStyle}
        >
          <span>
            {filterOptions.find((opt) => opt.value === filterType)?.label ||
              "All"}
          </span>
          <span className="dropdown-arrow">
            {greyChevronDropdownIcon ? (
              <GreyChevronDropdownIcon open={isDropdownOpen} />
            ) : isDropdownOpen ? (
              "▲"
            ) : (
              "▼"
            )}
          </span>
        </div>
        {isDropdownOpen && (
          <div className="dropdown-options">
            {filterOptions.map((option) => {
              let isoptdisbld = disabledFltrOptions.find((o) =>
                typeof o === "string"
                  ? o === option.value
                  : o.value === option.value
              );
              return (
                <div
                  key={option.value}
                  className={`radio-option ${
                    filterType === option.value ? "selected" : ""
                  } ${isoptdisbld ? "disabled-option" : ""}`}
                  onClick={() => {
                    if (isoptdisbld) return;
                    setFilterType(option.value);
                    setIsDropdownOpen(false);
                  }}
                >
                  <input
                    type="radio"
                    name="filterType"
                    value={option.value}
                    checked={filterType === option.value}
                    disabled={isoptdisbld}
                    onChange={() => {}}
                  />
                  <span className="radio-label">{option.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default FilterDropdown;
